import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardHeader, CardContent, Container, Typography, Grid } from "@mui/material";
import rmsActions from "../../../../actions/rmsActions";
import { getCategories, getRmsAppCode, isFetching } from "../../../../reducers";
import { DataTypes } from "../../../../constants";
import Fetching from "../../../Common/Fetching";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import ListCategories from "./ListCategories";
import PORTAvatar from "../PORTAvatar";


const CategoryList = () => {
    const dispatch = useDispatch();

    const appCode = useSelector(getRmsAppCode);
    const categories = useSelector(getCategories);
    const fetching = useSelector((state) => isFetching(state, DataTypes.CATEGORIES));

    useEffect(() => {
        if (!!appCode) {
            dispatch(rmsActions.getCategories(appCode));
        }
    }, [dispatch, appCode]);

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                {fetching && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}

                {!fetching && (
                    <Grid item xs={12}>
                        <Card className="card">
                            <CardHeader
                                disableTypography={true}
                                avatar={<PORTAvatar type={"category"} />}
                                title={
                                    <Typography component="h2" className="card-header-title" >
                                        Categories
                                    </Typography>
                                }
                                subheader={
                                    <Typography component="span" className="card-header-subtitle" >
                                        Portfolio categories
                                    </Typography>
                                }
                            />
                            <CardContent>
                                <ListCategories categories={categories} />
                            </CardContent>
                        </Card>
                    </Grid>
                )}
            </Grid>
        </Container>
    );
};

export default CategoryList;
